import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private selectedLang = new BehaviorSubject<string>(
    localStorage.getItem('lang') || 'en'
  );
  selectedLang$ = this.selectedLang.asObservable();

  constructor(private translate: TranslateService) {
    const lang = this.selectedLang.value;
    this.translate.use(lang);
  }

  setLanguage(lang: string) {
    this.selectedLang.next(lang);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  getLanguage() {
    return this.selectedLang.value;
  }
}
